import { ActionCampaign, FakeActionCampaign } from "../../common/types/actions";
import { User } from "../../common/types/user";
import { BookOnboardingCallActivity } from "./bookOnboardingCall/BookOnboardingCallActivity";
import { ConfirmTransactionsActivity } from "./confirmTransactions/ConfirmTransactionsActivity";
import { InviteAccountantActivity } from "./inviteAccountant/InviteAccountantActivity";
import { IRSRequirementsActivity } from "./irsRequirements/IRSRequirementsActivity";
import { PersonalToBusinessActivity } from "./personalToBusiness/PersonalToBusinessActivity";
import { SetupReceiptMatchingActivity } from "./setupReceiptMatching/SetupReceiptMatchingActivity";
import { WelcomeVideoActivity } from "./welcomeVideo/WelcomeVideoActivity";
import { CategorizedTransactionsActivity } from "./fake/categorizedTransactions/CategorizedTransactionsActivity";
import { MatchedReceiptsActivity } from "./fake/matchedReceipts/MatchedReceiptsActivity";
import { ConnectedAccountsActivity } from "./fake/connectedAccounts/ConnectedAccountsActivity";
import { CreatedJournalEntriesActivity } from "./fake/createdJournalEntries/CreatedJournalEntriesActivity";
import { UploadReceiptsActivity } from "./uploadReceipts/UploadReceiptsActivity";
import { ReconnectAccountsActivity } from "./reconnectAccounts/ReconnectAccountsActivity";
import { CategorizeTransactionsActivity } from "./categorizeTransactions/CategorizeTransactionsActivity";
import { TransferMatchTransactionsActivity } from "./transferMatchTransactions/TransferMatchTransactionsActivity";
import { SubstantiateTransactionsActivity } from "./substantiateTransactions/SubstantiateTransactionsActivity";

export interface CampaignActivityProps {
    campaign: ActionCampaign | FakeActionCampaign;
    count: number;
    amountSaved: number;
    animated: boolean;
    description?: string;
    user?: User;
}

const CAMPAIGN_ACIVITIES: Record<
    ActionCampaign | FakeActionCampaign,
    React.ComponentType<CampaignActivityProps>
> = {
    [ActionCampaign.BOOK_ONBOARDING_CALL]: BookOnboardingCallActivity,
    [ActionCampaign.CONFIRM_TRANSACTIONS]: ConfirmTransactionsActivity,
    [ActionCampaign.INVITE_ACCOUNTANT]: InviteAccountantActivity,
    [ActionCampaign.IRS_REQUIREMENTS]: IRSRequirementsActivity,
    [ActionCampaign.UPLOAD_RECEIPTS]: UploadReceiptsActivity,
    [ActionCampaign.PERSONAL_TO_BUSINESS]: PersonalToBusinessActivity,
    [ActionCampaign.SETUP_RECEIPT_MATCHING]: SetupReceiptMatchingActivity,
    [ActionCampaign.WELCOME_VIDEO]: WelcomeVideoActivity,
    [FakeActionCampaign.CATEGORIZED_TRANSACTIONS]:
        CategorizedTransactionsActivity,
    [FakeActionCampaign.MATCHED_RECEIPTS]: MatchedReceiptsActivity,
    [FakeActionCampaign.CONNECTED_ACCOUNTS]: ConnectedAccountsActivity,
    [FakeActionCampaign.CREATED_JOURNAL_ENTRIES]: CreatedJournalEntriesActivity,
    [ActionCampaign.RECONNECT_ACCOUNTS]: ReconnectAccountsActivity,
    [ActionCampaign.CATEGORIZE_TRANSACTIONS]: CategorizeTransactionsActivity,
    [ActionCampaign.MATCH_TRANSACTIONS]: TransferMatchTransactionsActivity,
    [ActionCampaign.SUBSTANTIATE_TRANSACTIONS]:
        SubstantiateTransactionsActivity,
};

export const ActionActivityItem: React.FC<CampaignActivityProps> = (props) => {
    const Activity = CAMPAIGN_ACIVITIES[props.campaign];
    return <Activity {...props} />;
};
